@if (!site || !entity) {
    <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
}
<div class="entity-header">
    <ws-bread-crumbs [breadcrumbs]="breadcrumbs" [currentPageTitle]="site?.name"></ws-bread-crumbs>
</div>
@if (entity && site) {
    <div [ngClass]="{ 'panel-maximized': panelMaximized }" class="site-page ws-flex-container-vertical ws-stretch">
        <div class="row equal-panel panel-container">
            <div class="col-xl-5">
                <site-info-panel [site]="site"></site-info-panel>
            </div>
            <div class="col-xl-7">
                <div class="activity-and-analysis card panel-flat-color secondary-panel">
                    <div class="panel-flat-header">
                        <h3>Activity and Analysis</h3>
                        <assessment-taxes-details-icon [siteId]="entity.id" class="ms-2">
                        </assessment-taxes-details-icon>
                    </div>
                    <div class="panel-flat-body p-0">
                        @if (parcelYears) {
                            <activity-panel [parcelYears]="parcelYears" [siteId]="siteId"> </activity-panel>
                        }
                    </div>
                </div>
            </div>
        </div>
        <div
            [ngClass]="{
                'ws-flex-none': panelMaximized !== 'form-parcel-list' && panelMaximized !== 'propertyCharacteristics',
                'ws-flex-auto': panelMaximized !== 'form-parcel-list' && panelMaximized !== 'propertyCharacteristics',
                'site-parcel-row':
                    panelMaximized !== 'form-parcel-list' && panelMaximized !== 'propertyCharacteristics',
                'panel-container': panelMaximized === 'responsibleEntityPanel',
            }"
            class="row equal-panel d-flex h-100"
        >
            @if (parcelYears) {
                <div
                    [ngClass]="{ 'current-max-panel-flex': panelMaximized === 'form-parcel-list' }"
                    class="panel-container ws-flex-container-vertical site-parcel-list-panel"
                >
                    <parcel-list-panel
                        [hasSiteWritePermission]="entity.hasWritePermission"
                        [maximize]="maximizePanel"
                        [minimize]="minimizePanel"
                        [ngClass]="{ 'ws-stretch': panelMaximized }"
                        [parcelYears]="parcelYears"
                        [site]="site"
                        class="d-flex flex-column h-100"
                    >
                    </parcel-list-panel>
                </div>
            }
            <div
                [ngClass]="{ 'current-max-panel-margin': panelMaximized === 'propertyCharacteristics' }"
                class="panel-container ws-flex-container-vertical site-characteristics-panel"
            >
                <entity-property-characteristics class="h-100"></entity-property-characteristics>
            </div>
        </div>
        <div class="row panel-container">
            <div class="col-xl-12">
                <client-services-panel [entity]="entity"></client-services-panel>
            </div>
        </div>
        @if (showReferralsPanel) {
            <div class="row panel-container">
                <div class="col-xl-12">
                    <referrals-panel [siteId]="siteId"></referrals-panel>
                </div>
            </div>
        }
        <div class="row panel-container">
            <div class="col-xl-12">
                <asset-list-panel
                    [companyId]="topLevelCompanyId"
                    [showComplianceInfo]="showComplianceInfo"
                    [siteId]="siteId"
                >
                </asset-list-panel>
            </div>
        </div>
        <div
            [ngClass]="{
                'ws-flex-none': panelMaximized !== 'responsibleEntityPanel',
                'ws-flex-auto': panelMaximized === 'responsibleEntityPanel',
                'site-parcel-row': panelMaximized === 'responsibleEntityPanel',
            }"
            class="row ws-flex-container-horizontal"
        >
            <div
                [ngClass]="{ 'current-max-panel-margin': panelMaximized === 'responsibleEntityPanel' }"
                class="panel-container ws-flex-container-vertical site-characteristics-panel"
            >
                <responsible-entity-panel
                    [companyId]="topLevelCompanyId"
                    [enableAllocations]="enableAllocations"
                    [siteId]="siteId"
                >
                </responsible-entity-panel>
            </div>
        </div>
        @if (site && site.hasValuationData) {
            <div class="row panel-container">
                <div class="col-xl-12">
                    <valuation-panel [companyId]="companyId" [siteId]="siteId"></valuation-panel>
                </div>
            </div>
        }
        @if (hasPrivateItemsPermission) {
            <div class="row panel-container">
                <div class="col-xl-12">
                    <contract-terms-panel-site [entity]="entity"></contract-terms-panel-site>
                </div>
            </div>
        }
        @if (hasPrivateItemsPermission) {
            <div class="row panel-container">
                <div class="col-xl-12">
                    <invoice-panel [allowEdit]="hasRyanPrivateItemsEdit" [site]="site"></invoice-panel>
                </div>
            </div>
        }
        <div class="row panel-container">
            <div class="col-xl-12">
                @if (entity.id) {
                    <contacts-panel [entity]="entity"></contacts-panel>
                }
            </div>
        </div>
    </div>
}
